import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <Section background="darker" data-id="element-1">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-2">
        {/* For You */}
        <div className="bg-slate-900/50 p-8 rounded-2xl border border-green-500/20" data-id="element-3">
          <h3 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-4">
            <span className="bg-green-500/10 text-green-500 p-2 rounded-lg mr-3" data-id="element-5">
              <Check className="h-6 w-6" data-id="element-6" />
            </span>
            Es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-7">
            {['Ya operas y quieres consistencia', 'Te saboteas por FOMO/revenge/sobreoperación', 'Quieres un sistema simple, aplicable a cualquier mercado'].map((item, i) => <li key={i} className="flex items-start text-slate-300" data-id="element-8">
                <Check className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-9" />
                {item}
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-slate-900/50 p-8 rounded-2xl border border-red-500/20" data-id="element-10">
          <h3 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-11">
            <span className="bg-red-500/10 text-red-500 p-2 rounded-lg mr-3" data-id="element-12">
              <X className="h-6 w-6" data-id="element-13" />
            </span>
            NO es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-14">
            {['Buscas señales o “entradas ganadoras”', 'No estás dispuesto a seguir reglas', 'Buscas una fórmula mágica sin esfuerzo'].map((item, i) => <li key={i} className="flex items-start text-slate-300" data-id="element-15">
                <X className="h-5 w-5 text-red-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-16" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}